// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1nC_2","modalFooterButton":"ModalNotes_modalFooterButton__1sS79"};